<template>
  <div>
    <GmapMap
      :center="center"
      :zoom="15"
      :options="mapStyles"
      style="width: 100%; height: 900px"
    >
      <GmapMarker
        :position="vanPosition"
        :icon="{ url: require('../assets/camioneta.png') }"
      />

      <GmapMarker
        :position="hotelPosition"
        :icon="{ url: require('../assets/hotel-icon.png') }"
      />

      <GmapMarker
        :position="airportPosition"
        :icon="{ url: require('../assets/airport-icon.png') }"
      />

      <GmapPolyline :path.sync="path" :options="{ strokeColor: '#008000' }">
      </GmapPolyline>
    </GmapMap>
  </div>
</template>

<script>
export default {
  name: "GoogleMap",
  props: {
    stop: Object,
  },
  data() {
    return {
      center:{lng: -80.27010440826415, lat: 25.801977590099177 }, 
      hotelPosition :{lng: -80.276655, lat: 25.808260 },
      airportPosition :{ lng: -80.275442, lat: 25.796595 },
      path: [
        { lng: -80.275442, lat: 25.796595 },
        { lng: -80.277344, lat: 25.796515 },
        { lng: -80.277475, lat: 25.79649 },
        { lng: -80.277594, lat: 25.796444 },
        { lng: -80.278137, lat: 25.79613 },
        { lng: -80.278243, lat: 25.796051 },
        { lng: -80.278325, lat: 25.795941 },
        { lng: -80.278468, lat: 25.795683 },
        { lng: -80.27848, lat: 25.795619 },
        { lng: -80.278419, lat: 25.794498 },
        { lng: -80.278363, lat: 25.794391 },
        { lng: -80.278245, lat: 25.794222 },
        { lng: -80.278145, lat: 25.794109 },
        { lng: -80.278071, lat: 25.794058 },
        { lng: -80.277369, lat: 25.793727 },
        { lng: -80.277251, lat: 25.793708 },
        { lng: -80.276547, lat: 25.793737 },
        { lng: -80.274767, lat: 25.79381 },
        { lng: -80.273177, lat: 25.793877 },
        { lng: -80.272481, lat: 25.793907 },
        { lng: -80.271976, lat: 25.793979 },
        { lng: -80.271371, lat: 25.794146 },
        { lng: -80.271164, lat: 25.794182 },
        { lng: -80.270875, lat: 25.794194 },
        { lng: -80.27043, lat: 25.794227 },
        { lng: -80.269056, lat: 25.794368 },
        { lng: -80.267561, lat: 25.794578 },
        { lng: -80.267036, lat: 25.794706 },
        { lng: -80.266386, lat: 25.79455 },
        { lng: -80.266122, lat: 25.794466 },
        { lng: -80.266012, lat: 25.794421 },
        { lng: -80.26585, lat: 25.794328 },
        { lng: -80.26522, lat: 25.793973 },
        { lng: -80.264993, lat: 25.793877 },
        { lng: -80.264761, lat: 25.793813 },
        { lng: -80.264502, lat: 25.793784 },
        { lng: -80.264262, lat: 25.793786 },
        { lng: -80.264022, lat: 25.793824 },
        { lng: -80.263792, lat: 25.793895 },
        { lng: -80.263678, lat: 25.793945 },
        { lng: -80.263478, lat: 25.794057 },
        { lng: -80.263284, lat: 25.794206 },
        { lng: -80.263064, lat: 25.794442 },
        { lng: -80.262932, lat: 25.79468 },
        { lng: -80.262822, lat: 25.794901 },
        { lng: -80.262781, lat: 25.795112 },
        { lng: -80.262793, lat: 25.795384 },
        { lng: -80.262863, lat: 25.795598 },
        { lng: -80.262935, lat: 25.795731 },
        { lng: -80.263067, lat: 25.795895 },
        { lng: -80.263633, lat: 25.796397 },
        { lng: -80.263858, lat: 25.796663 },
        { lng: -80.26397, lat: 25.796847 },
        { lng: -80.264076, lat: 25.797116 },
        { lng: -80.264172, lat: 25.797604 },
        { lng: -80.264189, lat: 25.797951 },
        { lng: -80.264209, lat: 25.798402 },
        { lng: -80.264282, lat: 25.798525 },
        { lng: -80.264343, lat: 25.798457 },
        { lng: -80.264295, lat: 25.798424 },
        { lng: -80.26429, lat: 25.798462 },
        { lng: -80.26429, lat: 25.798462 },
        { lng: -80.264282, lat: 25.798525 },
        { lng: -80.264286, lat: 25.798744 },
        { lng: -80.264294, lat: 25.798963 },
        { lng: -80.264297, lat: 25.799122 },
        { lng: -80.26431, lat: 25.799504 },
        { lng: -80.264324, lat: 25.800225 },
        { lng: -80.264344, lat: 25.800995 },
        { lng: -80.264343, lat: 25.801234 },
        { lng: -80.264344, lat: 25.801517 },
        { lng: -80.264346, lat: 25.801975 },
        { lng: -80.26435, lat: 25.80245 },
        { lng: -80.264369, lat: 25.80298 },
        { lng: -80.264384, lat: 25.803373 },
        { lng: -80.264389, lat: 25.803462 },
        { lng: -80.264388, lat: 25.803724 },
        { lng: -80.264374, lat: 25.804065 },
        { lng: -80.264316, lat: 25.804703 },
        { lng: -80.264292, lat: 25.804912 },
        { lng: -80.264188, lat: 25.805499 },
        { lng: -80.264061, lat: 25.806219 },
        { lng: -80.264033, lat: 25.806567 },
        { lng: -80.264047, lat: 25.806689 },
        { lng: -80.264239, lat: 25.807385 },
        { lng: -80.264263, lat: 25.807741 },
        { lng: -80.264274, lat: 25.808338 },
        { lng: -80.264277, lat: 25.808446 },
        { lng: -80.264575, lat: 25.808446 },
        { lng: -80.265043, lat: 25.808433 },
        { lng: -80.265244, lat: 25.808427 },
        { lng: -80.265609, lat: 25.808419 },
        { lng: -80.266001, lat: 25.80841 },
        { lng: -80.26661, lat: 25.808393 },
        { lng: -80.267116, lat: 25.808382 },
        { lng: -80.267629, lat: 25.808368 },
        { lng: -80.268655, lat: 25.808344 },
        { lng: -80.269104, lat: 25.808334 },
        { lng: -80.269296, lat: 25.808329 },
        { lng: -80.269656, lat: 25.808319 },
        { lng: -80.270663, lat: 25.808295 },
        { lng: -80.270916, lat: 25.808291 },
        { lng: -80.271103, lat: 25.808285 },
        { lng: -80.271289, lat: 25.80828 },
        { lng: -80.271495, lat: 25.808276 },
        { lng: -80.271682, lat: 25.808273 },
        { lng: -80.272279, lat: 25.808258 },
        { lng: -80.272394, lat: 25.808255 },
        { lng: -80.272687, lat: 25.808247 },
        { lng: -80.273357, lat: 25.808212 },
        { lng: -80.274047, lat: 25.808192 },
        { lng: -80.274742, lat: 25.808167 },
        { lng: -80.275382, lat: 25.808144 },
        { lng: -80.275881, lat: 25.808129 },
        { lng: -80.275921, lat: 25.808127 },
        { lng: -80.27648, lat: 25.808109 },
        { lng: -80.276491, lat: 25.808375 },
        { lng: -80.265129, lat: 25.808323 },
        { lng: -80.265025, lat: 25.808329 },
        { lng: -80.264569, lat: 25.808337 },
        { lng: -80.26456, lat: 25.808079 },
        { lng: -80.264556, lat: 25.807988 },
        { lng: -80.26452, lat: 25.807663 },
        { lng: -80.264489, lat: 25.80753 },
        { lng: -80.264298, lat: 25.807004 },
        { lng: -80.264239, lat: 25.806752 },
        { lng: -80.264201, lat: 25.806477 },
        { lng: -80.264206, lat: 25.806221 },
        { lng: -80.264255, lat: 25.805902 },
        { lng: -80.264458, lat: 25.804939 },
        { lng: -80.264511, lat: 25.804537 },
        { lng: -80.264575, lat: 25.803785 },
        { lng: -80.264566, lat: 25.80341 },
        { lng: -80.264542, lat: 25.801814 },
        { lng: -80.264544, lat: 25.801503 },
        { lng: -80.264592, lat: 25.801118 },
        { lng: -80.264602, lat: 25.800766 },
        { lng: -80.264697, lat: 25.799831 },
        { lng: -80.264678, lat: 25.799225 },
        { lng: -80.264664, lat: 25.798752 },
        { lng: -80.264597, lat: 25.79713 },
        { lng: -80.264603, lat: 25.795796 },
        { lng: -80.264623, lat: 25.795579 },
        { lng: -80.264715, lat: 25.795372 },
        { lng: -80.264772, lat: 25.795295 },
        { lng: -80.264856, lat: 25.795218 },
        { lng: -80.264955, lat: 25.795149 },
        { lng: -80.265062, lat: 25.7951 },
        { lng: -80.265279, lat: 25.795053 },
        { lng: -80.265876, lat: 25.794975 },
        { lng: -80.267013, lat: 25.794952 },
        { lng: -80.267721, lat: 25.794926 },
        { lng: -80.268345, lat: 25.794835 },
        { lng: -80.268952, lat: 25.794782 },
        { lng: -80.269332, lat: 25.794756 },
        { lng: -80.270132, lat: 25.79473 },
        { lng: -80.270749, lat: 25.794708 },
        { lng: -80.270844, lat: 25.795021 },
        { lng: -80.27099, lat: 25.795025 },
        { lng: -80.271146, lat: 25.795044 },
        { lng: -80.271304, lat: 25.795065 },
        { lng: -80.271742, lat: 25.795157 },
        { lng: -80.272053, lat: 25.795261 },
        { lng: -80.272203, lat: 25.795314 },
        { lng: -80.272377, lat: 25.795391 },
        { lng: -80.272727, lat: 25.795579 },
        { lng: -80.273518, lat: 25.796022 },
        { lng: -80.273666, lat: 25.796171 },
        { lng: -80.274027, lat: 25.796432 },
        { lng: -80.274184, lat: 25.796521 },
        { lng: -80.274328, lat: 25.796576 },
        { lng: -80.274476, lat: 25.796611 },
        { lng: -80.274631, lat: 25.796624 },
        { lng: -80.275048, lat: 25.796612 },
        { lng: -80.275442, lat: 25.796595 },
      ],
      mapStyles: {
        disableDefaultUI : true,
        styles: [
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                color: "#e9e9e9",
              },
              {
                lightness: 17,
              },
            ],
          },
          {
            featureType: "landscape",
            elementType: "geometry",
            stylers: [
              {
                color: "#f5f5f5",
              },
              {
                lightness: 20,
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#ffffff",
              },
              {
                lightness: 17,
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#ffffff",
              },
              {
                lightness: 29,
              },
              {
                weight: 0.2,
              },
            ],
          },
          {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [
              {
                color: "#ffffff",
              },
              {
                lightness: 18,
              },
            ],
          },
          {
            featureType: "road.local",
            elementType: "geometry",
            stylers: [
              {
                color: "#ffffff",
              },
              {
                lightness: 16,
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
              {
                color: "#f5f5f5",
              },
              {
                lightness: 21,
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
              {
                color: "#dedede",
              },
              {
                lightness: 21,
              },
            ],
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              {
                visibility: "on",
              },
              {
                color: "#ffffff",
              },
              {
                lightness: 16,
              },
            ],
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              {
                saturation: 36,
              },
              {
                color: "#333333",
              },
              {
                lightness: 40,
              },
            ],
          },
          {
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers: [
              {
                color: "#f2f2f2",
              },
              {
                lightness: 19,
              },
            ],
          },
          {
            featureType: "administrative",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#fefefe",
              },
              {
                lightness: 20,
              },
            ],
          },
          {
            featureType: "administrative",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#fefefe",
              },
              {
                lightness: 17,
              },
              {
                weight: 1.2,
              },
            ],
          },
        ],
      },
    };
  },
  computed: {
    vanPosition: function () {
      return { lat: this.stop.deviceLat, lng: this.stop.deviceLng };
    },
  },
  methods: {
    geolocate: function () {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },
  },
};
</script>